// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"21dcd054","552":"381e8ab3"}[chunkId] + ".chunk.css";
};